// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgPlay: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M21.529 11.136c.628.397.628 1.33 0 1.728L4.279 23.769C3.283 24.398 2 23.668 2 22.473V1.527C2 .332 3.284-.398 4.278.23z" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgPlay);
export default Memo;
